export default __webpack_public_path__ + "static/media/person.4b2fbbfb.png";